import React from 'react';
import PropTypes from 'prop-types';
import IncomeSection from '../IncomeSection';

const SimpleRevenueTab = ({ ctrl }) => (
  <div style={{ paddingBottom: 200 }}>
  <IncomeSection
    csrfToken={ctrl.csrfToken}
    team={ctrl.team}
    currentUser={ctrl.currentUser}
    offer={ctrl.offer}
    budget={ctrl.budgetForComponents}
    calculated={ctrl.calculated}
    updateBudget={ctrl.handleUpdateBudget}
    onPassThroughChange={ctrl.handlePassThroughChange}
    createTicketBudgetLineItem={ctrl.handleCreateTicketLineItem}
    createIncomeBudgetLineItem={ctrl.handleCreateIncomeLineItem}
    createAncillaryIncomeBudgetLineItem={ctrl.handleCreateAncillaryIncomeLineItem}
    createBeforeAdjustedDeductionsBudgetLineItem={ctrl.handleCreateBeforeAdjustedDeductionsLineItem}
    createAdditionBudgetLineItem={ctrl.handleCreateAdditionLineItem}
    deleteBudgetLineItem={ctrl.handleDeleteLineItem}
    autoSaveBudgetLineItem={ctrl.handleAutoSaveLineItem}
    formatCalculatedNumber={ctrl.formatCalculatedNumber}
    financeCategories={ctrl.financeCategories}
    onFinanceCategoryAdded={ctrl.addFinanceCategory}
    settlementTickets={ctrl.settlementTickets}
    addOnActuals={ctrl.addOnActuals}
    performers={ctrl.performers}
    onVisibilityChange={ctrl.handleVisibilityChange}
    showCurrencyConversion={ctrl.showCurrencyConversion}
    globalCurrency={ctrl.globalCurrency}
    reorderLineItem={ctrl.reorderLineItem}
    onReorderLineItems={ctrl.handleReorderLineItems}
    allLineItems={ctrl.lineItems}
  />
  </div>
);

SimpleRevenueTab.propTypes = { ctrl: PropTypes.object.isRequired };

export default SimpleRevenueTab;
